import StackTrace from "stacktrace-js";

import packageJSON from "../../../package.json";

const { version } = packageJSON;
const consoleError = console.error;
//
export default class Logging {
  constructor(__, _) {
    this._ = _;

    // NOTES ON TESTING THE HANDLER
    // Chrome Console runs its error handler in a separate context, you need to create your own event to trigger the global error handler.
    // To test, run this in the console:

    // customErrorEvent = new Event("error");
    // customErrorEvent.error = new Error("Test Error");
    // window.dispatchEvent(customErrorEvent);

    if (typeof window !== "undefined") {
      console.error = this.logException;

      window.addEventListener(
        "error",
        event => this.logException(event.error, event),
        true
      );
    }
  }

  logException = (error, ...rest) => {
    if (error) {
      consoleError(error, ...rest);

      if (process.env.NODE_ENV !== "development" && error.stack) {
        // send to error dashboard
        this.logToGoogleErrorReporting(error).catch(consoleError);
      }
    }
  };

  logToGoogleErrorReporting = async error => {
    const enrichedFrames = await StackTrace.fromError(error);
    const stringifiedFrames = enrichedFrames
      .map(sf => sf.toString())
      .join("\n\t at ");
    const stackTraceMessage = `${error.message}\n\tat\t${stringifiedFrames}`;

    // first frame is where the error originated
    const [
      // keep the defaults to allow for testing in prod via synthetic events, this is required info for the API below
      {
        fileName = "error from console",
        lineNumber = 0,
        functionName = "error from console"
      } = {}
    ] = enrichedFrames;

    if (error?.stack) {
      await fetch(
        "https://clouderrorreporting.googleapis.com/v1beta1/projects/bytez-web-services/events:report?key=AIzaSyB-SbDR09aIXqo9iTAa65Mguqw-3IPpGqc",
        {
          method: "post",
          // mode: "no-cors",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({
            serviceContext: {
              service: "Bytez Next.js App",
              version,
              resourceType: "firebase_domain"
            },
            message: stackTraceMessage,
            context: {
              user: this._?.user?.session?.uid,
              httpRequest: { userAgent: navigator.userAgent },
              reportLocation: { filePath: fileName, lineNumber, functionName }
            }
          })
        }
      );
    }
  };
}
